import type { ApplicationKeyNameMapping } from './types';

const API_KEY_JIRA = '0678af2a-df89-42a3-4abb-60978aa54814';

export const APP_KEY_NAME_MAPPING: ApplicationKeyNameMapping = {
	business: {
		apiKey: API_KEY_JIRA,
		appName: 'jwm',
		editionKey: 'core',
	},
	software: {
		apiKey: API_KEY_JIRA,
		appName: 'jsw',
		editionKey: 'software',
	},
	service_desk: {
		apiKey: API_KEY_JIRA,
		appName: 'jsm',
		editionKey: 'serviceDesk',
	},
	customer_service: {
		apiKey: API_KEY_JIRA,
		appName: 'jcs',
		editionKey: 'customerService',
	},
	common: {
		apiKey: API_KEY_JIRA,
		appName: 'common',
		editionKey: 'common',
	},
	product_discovery: {
		apiKey: '',
		appName: 'jpd',
		editionKey: 'productDiscovery',
	},
};
